import { IPopupModel, IPopupModelV2 } from '@mwe/models';
import { UmmeldungSavePopupComponent } from '../../pages/ummeldung-wizard/components';

export const MARK_UMMELDUNG_AS_SENT_POPUP: IPopupModel = {
  id: 'mark-as-sent',
  titleKey: 'ummeldung.popup.markAsSent.title',
  messageKey: 'ummeldung.popup.markAsSent.message',
  showSubmitButton: true,
  submitButtonKey: 'ummeldung.popup.markAsSent.button.confirm',
  showCancelButton: true,
  cancelButtonKey: 'ummeldung.popup.markAsSent.button.cancel',
  iconTypeClass: 'fas fa-solid fa-question',
};

export const UMMELDUNG_IS_LOCKED_POPUP: IPopupModel = {
  id: 'ummeldung-locked-popup',
  titleKey: 'ummeldung.popup.isLocked.title',
  messageKey: 'ummeldung.popup.isLocked.message',
  showSubmitButton: true,
  submitButtonKey: 'ummeldung.popup.isLocked.button.confirm',
  showCancelButton: false,
  iconColorClass: 'yellow',
  iconTypeClass: 'fa-regular fa-siren-on',
};

export const UMMELDUNG_DOWNLOAD_ERROR_POPUP: IPopupModel = {
  id: 'download-error',
  titleKey: 'ummeldung.download.errors.title',
  messageKey: 'ummeldung.download.errors.message',
  showSubmitButton: true,
  showCancelButton: true,
  submitButtonKey: 'ummeldung.download.errors.primaryLink',
  cancelButtonKey: 'ummeldung.download.errors.secondaryLink',
  iconColorClass: 'red',
  iconTypeClass: 'fa-bell',
};

export const UMMELDUNG_OPEN_ERROR_POPUP: IPopupModel = {
  id: 'ummeldung-open-error',
  titleKey: 'ummeldung.popup.openError.title',
  messageKey: 'ummeldung.popup.openError.message',
  showSubmitButton: true,
  submitButtonKey: 'ummeldung.popup.openError.closeButton',
  showCancelButton: false,
  iconColorClass: 'red',
  iconTypeClass: 'fa-bell',
};

export const UMMELDUNG_EXIT_POPUP: IPopupModelV2 = {
  id: 'ummeldung-confirm-exit',
  modalSize: 'md',
  component: UmmeldungSavePopupComponent,
  titleKey: 'ummeldung.confirmExitPopup.title',
  componentData: {
    messageKey: 'ummeldung.confirmExitPopup.description',
    iconColorClass: 'blue',
    iconTypeClass: 'fas fa-solid fa-question',
  },
  dismissable: false,
};

export const UMMELDUNG_INVALID_EXIT_POPUP: IPopupModel = {
  id: 'ummeldung-invalid-exit',
  modalSize: 'md',
  titleKey: 'ummeldung.invalidExitPopup.title',
  messageKey: 'ummeldung.invalidExitPopup.description',
  iconColorClass: 'yellow',
  iconTypeClass: 'fa-regular fa-siren-on',
  showSubmitButton: true,
  submitButtonKey: 'ummeldung.invalidExitPopup.button.closeWithoutSaving',
  showCancelButton: true,
  cancelButtonKey: 'ummeldung.invalidExitPopup.button.cancel',
  dismissable: false,
};
